import { AvField, AvForm } from 'availity-reactstrap-validation'
import { useEffect, useState } from 'react'

const TicketSubject = ({ isEditMode, data, setUpdatedData }) => {
  const [value, setValue] = useState(data?.ticket?.subject)

  useEffect(() => {
    setValue(data?.ticket?.subject)
  }, [data?.ticket?.subject])
  if (!isEditMode) return <div className='subtitle1 text-muted'>{data?.ticket?.subject}</div>
  return (
    <AvForm>
      <AvField
        name='subject'
        value={value}
        className='subtitle1'
        onChange={(e) => {
          setValue(e.target.value)
          setUpdatedData((data) => {
            return {
              ...data,
              ['subject']: e.target.value,
            }
          })
        }}></AvField>
    </AvForm>
  )
}

export default TicketSubject
